import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getAllGroups} from '../../../actions/groups'
import MultiSelect from '../../common/form/multi-select'
import RequiredMultiSelect from '../../common/form/elements/required-multi-select'

class GroupMultiSelect extends Component {

  componentWillMount() {
    this.props.dispatch(getAllGroups());
  }

  render() {
    const {required, groups, all, value, ...rest} = this.props;

    const Select = required ? RequiredMultiSelect : MultiSelect;

    const data = groups.map(group => ({
      label: group.attributes.name,
      value: group.id
    }));

    const selectValue = all ? ['all'] : value;

    return (
      <Select
        withAllOption
        data={data}
        value={selectValue}
        label="Eligible groups"
        messages={{
          required: 'You must select at least one group'
        }}
        {...rest}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  groups: state.groups.groups
});

export default connect(mapStateToProps)(GroupMultiSelect);



// WEBPACK FOOTER //
// ./src/components/common/groups/group-multi-select.jsx